import React from "react";
import { Link } from 'react-router-dom'
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import PageInfo from "./PageInfo";
import Button from '@material-ui/core/Button';
import PageDetailsIcon from '@material-ui/icons/ChevronRight';

import PageActionRecommender from './PageActionRecommender';

const runningLocal = process.env.REACT_APP_API_DOMAIN !== "sc";
const ItemService = runningLocal ?
  require("../data/ItemService.dev").default :
  require("../data/ItemService.prod").default;

const styles = theme => ({
  list: {
    width: 350
  },
  fullList: {
    width: "auto"
  },
  backdrop: {
    backgroundColor: 'transparent'
  },
  button: {
    position: 'absolute',
    right: '5px',
    top: '0',
    zIndex: '1',
    margin: theme.spacing.unit,
  },
});

class PageInfoDrawer extends React.Component {

  state = {
    pageMetrics: null,
    contentItem: null,
    recommendations: null,
    pageMetricsToLoad: null
  }

  static getDerivedStateFromProps(nextProps, prevState) {

    console.log("getDerivedStateFromProps()");

    let { pageMetrics } = nextProps;
    if (pageMetrics === undefined || pageMetrics === null) {
      //probably the first rendering of this component
      return null;
    }

    if (prevState.pageMetrics === null || prevState.pageMetrics.id !== pageMetrics.id) {
      //update if state is null or the metrics changed
      return {
        pageMetricsToLoad: pageMetrics
      };
    }

    return null;
  }

  shouldComponentUpdate() {
    console.log("shouldComponentUpdate()");
    // if (!this.state) { return true; }

    // const { selectedPage } = this.props;
    // const { currentPage } = this.state;

    // if (selectedPage === null) {
    //   return false;
    // }

    return true;
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.pageMetricsToLoad === null) { return; }
    if (this.state.pageMetricsToLoad === prevState.pageMetricsToLoad) { return; }

    this._loadPageDetails(this.state.pageMetricsToLoad);
  }

  _loadPageDetails(pageMetrics) {
    //query content to get additional page info (this will be moved elsewhere)
    Promise.resolve(ItemService.getItemDataByPath(pageMetrics.path)).then(item => {
      let recommendations = PageActionRecommender.getRecommendations(pageMetrics, item);
      this.setState({
        pageMetrics: pageMetrics,
        contentItem: item,
        recommendations: recommendations
      });
    });
  }

  render() {
    const { classes, isOpen, closeDrawer } = this.props;
    const { pageMetrics, contentItem, recommendations } = this.state;

    console.log(contentItem);

    return (
      <Drawer anchor="right"
        open={isOpen}
        onClose={closeDrawer}
        ModalProps={{
          BackdropProps: {
            className: classes.backdrop,
          },
        }}>
        {/* <div>
          {pageMetrics ? (
            <Link to={`/page/${contentItem.id}/${pageMetrics.id}`}>
              <Button variant="fab" color="secondary" aria-label="add" className={classes.button}>
                <PageDetailsIcon />
              </Button>
            </Link>
          ) : null}
          <div className={classes.list}>
            {pageMetrics ? (
              <PageInfo
                pageMetrics={pageMetrics}
                contentItem={contentItem}
                recommendations={recommendations}
              />
            ) : null}
          </div>
        </div> */}
      </Drawer>
    );
  }
}

PageInfoDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  closeDrawer: PropTypes.func.isRequired
};

export default withStyles(styles)(PageInfoDrawer);



// WEBPACK FOOTER //
// ./src/components/PageInfoDrawer.js